export default "__VITE_PUBLIC_ASSET__4d515e5d__"